//import { UserType } from "../lib/user";
import { User, UserType } from "../lib/user";
import { currency, email, cf } from "../lib/validators";
import { Pratica, StatiPratica } from "../types";
//import { StatiPratica } from "../types";

type TODO = any[];

const form: TODO = [
  //DATI BENEFICIARIO
  {
    name: "Beneficiario",
    fields: [
      // {
      //   type: "radio-group",
      //   name: "Tipo",
      //   id: "type",
      //   initialValue: "0",
      //   items: 3,
      //   required: true,
      //   options: [
      //     {
      //       name: "Persona Fisica",
      //       value: "0",
      //       default: true,
      //     },
      //     // {
      //     //   name: "Persona Giuridica",
      //     //   value: "1",
      //     // },
      //   ],
      // },
      // {
      //   type: "label",
      //   initialValue: "Dati società",
      //   id: "label-persona-giuridica",
      //   if: (values: Record<string, any>) =>
      //     values.type ? values.type === "1" : true,
      // },
      {
        name: "Cognome",
        id: "cognome",
        // if: (values: Record<string, any>) =>
        //   values.type ? values.type === "0" : true,
        required: true,
      },
      {
        name: "Nome",
        id: "nome",
        // if: (values: Record<string, any>) =>
        //   values.type ? values.type === "0" : true,
        required: true,
      },
      // {
      //   name: "Nome e Cognome",
      //   id: "beneficiario",
      //   if: (values: Record<string, any>) => values.type === "1",
      //   required: true,
      // },
      // {
      //   name: "Ragione Sociale",
      //   id: "beneficiario-giuridico",
      //   if: (values: Record<string, any>) => values.type === "1",
      //   required: true,
      // },
      // {
      //   name: "Partita IVA",
      //   id: "piva",
      //   if: (values: Record<string, any>) => values.type === "1",
      //   required: true,
      // },
      // {
      //   name: "Codice Fiscale",
      //   id: "codice-fiscale",
      //   if: (values: Record<string, any>) => values.type !== "1",
      //   validate: cf,
      //   required: true,
      // },
      {
        name: "Email",
        id: "email",
        validate: email,
        required: true,
      },
      {
        name: "Telefono",
        id: "telefono",
        required: true,
      },
      {
        name: "Indirizzo",
        id: "address",
        desc: "eg. Via Fulvio Testi 32, 20100, Milano (MI)",
        required: true,
      },
      // {
      //   name: "Upload visura",
      //   id: "persona-giuridica-visura-fronte",
      //   type: "file",
      //   if: (values: Record<string, any>) => values.type === "1",
      //   required: true,
      // },

      // {
      //   type: "radio-group",
      //   name: "È anche intestatario immobile",
      //   id: "is-intestatario-immobile",
      //   initialValue: "0",
      //   options: [
      //     {
      //       name: "Si",
      //       value: "0",
      //       default: true,
      //     },
      //     {
      //       name: "No",
      //       value: "1",
      //     },
      //   ],
      //   if: (values: Record<string, any>) => values.type !== "2",
      // },
      // {
      //   name: "Visura catastale o F24 pagamento IMU",
      //   id: "file-visura-catastale-f-24",
      //   type: "file",
      //   if: (values: Record<string, any>) =>
      //     values.type !== "2" && values["is-intestatario-immobile"] === "0",
      //   required: true,
      // },
      // {
      //   name: "Estremi di registrazione del contratto di locazione o comodato",
      //   id: "file-estremi-registrazione",
      //   type: "file",
      //   if: (values: Record<string, any>) =>
      //     values.type !== "2" && values["is-intestatario-immobile"] === "1",
      //   required: true,
      // },
      // {
      //   name:
      //     "Dichiarazione di consenso del proprietario all'esecuzione dell'intervento",
      //   id: "filedichiarazione-consenso-propr-esecuz-int",
      //   type: "file",
      //   if: (values: Record<string, any>) =>
      //     values.type !== "2" && values["is-intestatario-immobile"] === "1",
      //   required: true,
      //   fac_simile:
      //     "/docs/dichiarazione-consenso-proprietario-al-conduttore.pdf",
      // },
      // {
      //   name:
      //     "Dichiarazione del proprietario rilasciata al possessore dell’immobile per il consenso all’esecuzione lavori, se è necessario (in tal caso compilare “Dichiarazione consenso proprietario al conduttore” consegnata alla firma del contratto di assistenza)",
      //   id: "file-dichiarazione-proprietario",
      //   type: "file",
      //   if: (values: Record<string, any>) =>
      //     values["intestatario-immobile"] === "1",
      //   required: true,
      // },

      {
        name: "Codice Fiscale",
        desc:
          "Se la scansione del codice fiscale contiene sia il fronte che il retro del documento è consentito ignorare il campo 'Retro'",
        type: "group",
        id: "_cf-group",
        fields: [
          {
            type: "row",
            items: 2,
            fields: [
              {
                name: "Fronte",
                id: "cf-fronte",
                type: "file",
                required: true,
                delegabile: true,
              },
              {
                name: "Retro",
                id: "cf-retro",
                type: "file",
                delegabile: true,
              },
              {
                name: "Codice fiscale",
                id: "codice-fiscale",
                validate: cf,
              },
            ],
          },
        ],
      },
      {
        name: "Carta Identità",
        type: "group",
        id: "_ci-group",
        desc:
          "Se la scansione della carta d'identità contiene sia il fronte che il retro del documento è consentito ignorare il campo 'Retro'",
        fields: [
          {
            type: "row",
            items: 2,
            fields: [
              {
                name: "Fronte",
                id: "cid-fronte",
                type: "file",
                required: true,
                delegabile: true,
              },
              {
                name: "Retro",
                id: "cid-retro",
                type: "file",
                delegabile: true,
              },
            ],
          },
        ],
      },
      {
        name: "contratto d'affitto",
        id: "contratto-affitto",
        desc:
          "in caso di cliente affittuario caricare il contratto d'affitto nella parte del beneficiario ovviamente",
        type: "file",
        required: false,
      },
      {
        name: "Eventuali altri file",
        type: "group",
        id: "other-files",
        desc:
          "in questa area si possono caricare eventuali altri file di supporto all’asseverazione, come dichiarazioni o altri dati richiesti dai vistatori fiscali",
        fields: [
          {
            type: "row",
            items: 2,
            fields: [
              {
                name: "File 1",
                id: "file-1",
                type: "file",
              },
              {
                name: "File 2",
                id: "file-2",
                type: "file",
              },
            ],
          },
        ],
      },
    ],
  },
  //DATI INTERVENTO
  {
    name: "Documenti e dati intervento",
    fields: [
      {
        name: "Accordo per sconto in fattura",
        id: "accordo-sconto-fattura",
        type: "file",
        fac_simile: `${process.env.REACT_APP_DOCS_URL}#id_asseveratore#/1. Accordo per sconto in fattura.docx`,
        required: true,
      },
      {
        name: "Dichiarazione requisiti cliente",
        id: "dichiarazione-requisiti",
        type: "file",
        fac_simile: `${process.env.REACT_APP_DOCS_URL}#id_asseveratore#/2. Dichiarazione requisiti Cliente.docx`,
        required: true,
      },
      {
        name: "Lettera incarico Mediaworld",
        id: "lettera-incarico",
        type: "file",
        fac_simile: `${process.env.REACT_APP_DOCS_URL}#id_asseveratore#/3. Lettera Incarico Mediaworld.docx`,
        required: true,
      },
      {
        name: "Caricare una o più fotografie dell'installazione effettuata",
        id: "file-fotografie-installazione",
        desc:
          "caricare una foto dei vari dispositivi installati e opere eseguite, la foto deve includere l'etichetta del modello installato",
        type: "file",
        fnEditable: (
          values: Record<string, any>,
          user: User,
          pratica: Partial<Pratica>
        ) => {
          return (
            pratica.status != StatiPratica.Sent &&
            // pratica.status != StatiPratica.Completed &&
            user.type == UserType.Commesso
          );
        },
      },
      {
        name: "Caricare una o più fotografie del vecchio impianto",
        id: "file-fotografie-vecchio-impianto",
        desc:
          "caricare una foto dei vari dispositivi installati e opere eseguite, la foto deve includere l'etichetta del modello installato",
        type: "file",
        fnEditable: (
          values: Record<string, any>,
          user: User,
          pratica: Partial<Pratica>
        ) => {
          return (
            pratica.status != StatiPratica.Sent &&
            // pratica.status != StatiPratica.Completed &&
            user.type == UserType.Commesso
          );
        },
        //if: (values: Record<string, any>) => values["ecobonus-type"] === "1",
      },
      {
        name: "Note",
        id: "note-intervento",
        type: "text",
        //if: (values: Record<string, any>) => values["ecobonus-type"] === "1",
      },
    ],
  },
  //PRODOTTI AGEVOLATI
  {
    name: "Dati dei prodotti con agevolazione*",
    fields: [
      {
        type: "multiple",
        btnLabel: "Aggiungi prodotto",
        id: "nuovo-prodotto",
        list: "MW_productList",
        required: true,
      },
      {
        name: "Costo servizio d'installazione",
        id: "prezzo-installazione",
        required: true,
        type: "number",
        step: ".01",
        sanitize: currency,
      },
    ],
  },
  //PRODOTTI NON AGEVOLATI
  {
    name: "Dati dei prodotti senza agevolazione",
    fields: [
      {
        type: "multiple",
        btnLabel: "Aggiungi prodotto",
        id: "nuovo-prodotto-no-bonus",
        list: "MW_productList_noBonus",
      },
    ],
  },
  //RIEPILOGO TOTALI
  {
    name: "Riepilogo totali prodotti",
    fields: [
      {
        name: "Totale prodotti agevolati",
        id: "prezzo-totale",
        readonly: true,
      },
      {
        type: "radio-group",
        name: "Si tratta di intervento in edilizia libera?",
        id: "is-edilizia-libera",
        initialValue: "0",
        options: [
          {
            name: "Sì",
            value: "1",
            default: true,
          },
          {
            name: "No",
            value: "0",
          },
        ],
        required: true,
        if: (values: Record<string, any>) => {
          const total = parseFloat(
            values["prezzo-totale"]
              ?.replace("€", "")
              .replace(".", "")
              .replace(",", ".")
              .trim()
          );
          return total > 10000;
        },
      },
      {
        type: "label",
        id: "label-edilizia-libera",
        initialValue:
          "Pratica in valutazione dedicata, l'acquirente verrà contattato per acquisizione documentale supplementare",
        if: (values: Record<string, any>) =>
          values["is-edilizia-libera"] == "0",
      },
      {
        type: "radio-group",
        name: "Agevolazione",
        id: "ecobonus-type",
        initialValue: "0",
        options: [
          {
            name: "50%",
            value: "0",
            default: true,
          },
          // {
          //   name: "65%",
          //   value: "1",
          // },
        ],
      },
      {
        name: "Credito d'imposta oggetto di cessione",
        id: "credito-imposta",
        readonly: true,
      },
      {
        name: "Totale prodotti senza agevolazione",
        id: "prezzo-totale-no-bonus",
        readonly: true,
      },
      {
        name: "Totale pagamento riservato all'acquirente",
        id: "totale-pagamento",
        desc:
          "Totale prodotti agevolati + costo d'installazione + totale prodotti senza agevoalzione - credito d'imposta",
        readonly: true,
      },
    ],
  },
  //FATTURE
  {
    name: "Fatture e spese emesse al cliente*",
    fields: [
      {
        type: "multiple",
        btnLabel: "Nuova fattura/spesa",
        list: "fatturaList",
        id: "fattura-e-spese",
        required: true,
      },
    ],
  },

  //ALTRI FILES
  {
    name: "Altri documenti",
    fields: [
      {
        type: "multiple",
        btnLabel: "Allega documento",
        list: "otherFilesList",
        id: "other-files-list",
      },
    ],
  },

  //PAGAMENTO
  {
    name: "Dati pagamento",
    // tooltip: `Il cliente deve effetuare il saldo della vostra fattura tramite la modalità "bonifico parlante" a vostro conto corrente ( all'azienda che ha fatturato), trattasi di un tipo di bonifico speciale che nelle varie piattaforme di homebanking o allo sportello è definito come "bonifico per detrazioni fiscali o bonifico parlante". Nella causale deve essere indicato il Numero di fattura e la data di emissione.`,
    fields: [
      {
        type: "radio-group",
        name: "Il cliente ha fatto finanziamento?",
        id: "is-finanziamento",
        initialValue: "0",
        options: [
          {
            name: "No",
            value: "0",
            default: true,
          },
          {
            name: "Sì",
            value: "1",
          },
        ],
      },
      {
        type: "file",
        name: "Evidenza del ricevuto bonifico",
        id: "bonifico-parlante-singolo",
        required: true,
        if: (values: Record<string, any>) => values["is-finanziamento"] !== "1",
        delegabile: true,
      },
      {
        type: "file",
        name: "Bonifico finanziaria",
        id: "bonifico-finanziaria",
        required: true,
        if: (values: Record<string, any>) => values["is-finanziamento"] === "1",
        delegabile: true,
      },
    ],
  },
  //FILE AGGIUNTIVI
  {
    name: "File aggiuntivi",
    if: (
      values: Record<string, any>,
      user: User,
      pratica: Partial<Pratica>
    ) => {
      return (
        user?.type == UserType.Asseveratore ||
        pratica?.status == StatiPratica.NeedsReview
      );
    },
    fields: [
      {
        type: "file",
        name: "File 1",
        id: "file-1-agg",
        required: false,
        delegabile: true,
        fnEditable: (
          values: Record<string, any>,
          user: User,
          pratica: Partial<Pratica>
        ) => {
          const correzioni = pratica.correzioni as any;
          return (
            ((pratica.status as StatiPratica) < StatiPratica.Completed &&
              user.type == UserType.Asseveratore) ||
            ((pratica.status as StatiPratica) === StatiPratica.NeedsReview &&
              correzioni &&
              correzioni["file-1-agg"] &&
              user.type === UserType.Commesso)
          );
        },
      },
      {
        type: "file",
        name: "File 2",
        id: "file-2-agg",
        required: false,
        delegabile: true,
        fnEditable: (
          values: Record<string, any>,
          user: User,
          pratica: Partial<Pratica>
        ) => {
          const correzioni = pratica.correzioni as any;
          return (
            ((pratica.status as StatiPratica) < StatiPratica.Completed &&
              user.type == UserType.Asseveratore) ||
            ((pratica.status as StatiPratica) === StatiPratica.NeedsReview &&
              correzioni &&
              correzioni["file-2-agg"] &&
              user.type === UserType.Commesso)
          );
        },
      },
      {
        type: "file",
        name: "File 3",
        id: "file-3-agg",
        required: false,
        delegabile: true,
        fnEditable: (
          values: Record<string, any>,
          user: User,
          pratica: Partial<Pratica>
        ) => {
          const correzioni = pratica.correzioni as any;
          return (
            ((pratica.status as StatiPratica) < StatiPratica.Completed &&
              user.type == UserType.Asseveratore) ||
            ((pratica.status as StatiPratica) === StatiPratica.NeedsReview &&
              correzioni &&
              correzioni["file-3-agg"] &&
              user.type === UserType.Commesso)
          );
        },
      },
      {
        type: "file",
        name: "File 4",
        id: "file-4-agg",
        required: false,
        delegabile: true,
        fnEditable: (
          values: Record<string, any>,
          user: User,
          pratica: Partial<Pratica>
        ) => {
          const correzioni = pratica.correzioni as any;
          return (
            ((pratica.status as StatiPratica) < StatiPratica.Completed &&
              user.type == UserType.Asseveratore) ||
            ((pratica.status as StatiPratica) === StatiPratica.NeedsReview &&
              correzioni &&
              correzioni["file-4-agg"] &&
              user.type === UserType.Commesso)
          );
        },
      },
    ],
  },
  {
    name: "Documenti riservati all'emettitore",
    if: (
      values: Record<string, any>,
      user: User,
      pratica: Partial<Pratica>
    ) => {
      return (
        user.type == UserType.Commesso &&
        pratica.status == StatiPratica.NeedsReview
      );
    },
    fields: [
      {
        name: "Note",
        id: "notes-on-review",
        type: "text",
        fnEditable: (
          values: Record<string, any>,
          user: User,
          pratica: Partial<Pratica>
        ) => {
          return (
            user.type == UserType.Commesso &&
            pratica.status == StatiPratica.NeedsReview
          );
        },
      },
    ],
  },
  //ASSEVERATORE FISCALE
  {
    name: "Documenti riservati all'asseveratore fiscale",
    if: (
      values: Record<string, any>,
      user: User,
      pratica: Partial<Pratica>
    ) => {
      return (
        user.type == UserType.Asseveratore ||
        ((pratica.status == StatiPratica.Approved ||
          pratica.status == StatiPratica.Completed) &&
          user.type == UserType.Commesso)
      );
    },
    fields: [
      {
        name: "Comunicazione all'Agenzia delle Entrate",
        id: "comunicazione-agenzia-entrate",
        type: "file",
        fnEditable: (
          values: Record<string, any>,
          user: User,
          pratica: Partial<Pratica>
        ) => {
          return (
            (pratica.status as StatiPratica) < StatiPratica.Completed &&
            user.type == UserType.Asseveratore
          );
        },
      },
      {
        name:
          "Comunicazione all'Agenzia delle Entrate - copia firmata dal cliente",
        id: "comunicazione-agenzia-entrate-copia-cliente",
        type: "file",
        delegabile: true,
        fnEditable: (
          values: Record<string, any>,
          user: User,
          pratica: Partial<Pratica>
        ) => {
          return (
            pratica.status == StatiPratica.Approved &&
            user.type == UserType.Commesso
          );
        },
      },
      {
        name:
          "Asseverazione sulla congruità delle spese rilasciata dal tecnico",
        id: "asseverazione-spese-rilasciata-dal-tecnico",
        type: "file",
        fnEditable: (
          values: Record<string, any>,
          user: User,
          pratica: Partial<Pratica>
        ) => {
          return (
            (pratica.status as StatiPratica) < StatiPratica.Completed &&
            user.type == UserType.Asseveratore
          );
        },
        if: (values: Record<string, any>) => {
          const total = parseFloat(
            values["prezzo-totale"]
              ?.replace("€", "")
              .replace(".", "")
              .replace(",", ".")
              .trim()
          );
          return total > 10000;
        },
      },
      {
        name: "Scheda intervento trasmessa all’ENEA",
        id: "scheda-intervento-trasmessa-enea",
        type: "file",
        fnEditable: (
          values: Record<string, any>,
          user: User,
          pratica: Partial<Pratica>
        ) => {
          return (
            (pratica.status as StatiPratica) < StatiPratica.Completed &&
            user.type == UserType.Asseveratore
          );
        },
        if: (values: Record<string, any>) => {
          const total = parseFloat(
            values["prezzo-totale"]
              ?.replace("€", "")
              .replace(".", "")
              .replace(",", ".")
              .trim()
          );
          return total > 10000;
        },
      },
    ],
  },
  //ASSEVERATORE TECNICO
  {
    name: "Documenti riservati all'asseveratore tecnico",
    if: (values: Record<string, any>, user: User) => {
      return user.type == UserType.Asseveratore_tecnico;
    },
    fields: [
      {
        name: "Pratica ENEA",
        id: "file-pratiche-ENEA",
        type: "file",
        fnEditable: (values: Record<string, any>, user: User) => {
          return user.type == UserType.Asseveratore_tecnico;
        },
        //if: (values: Record<string, any>) => values["ecobonus-type"] === "1",
      },
      {
        name: "Ricevuta pratica ENEA",
        id: "ricevuta-pratiche-ENEA",
        type: "file",
        fnEditable: (values: Record<string, any>, user: User) => {
          return user.type == UserType.Asseveratore_tecnico;
        },
        //if: (values: Record<string, any>) => values["ecobonus-type"] === "1",
      },
      {
        name: "Dichiarazione congruità spesa",
        id: "file-dichiarazione-congruita-spesa",
        fac_simile: "/docs/facsimilidichiarazionicongruitecobonus.zip",
        type: "file",
        fnEditable: (values: Record<string, any>, user: User) => {
          return user.type == UserType.Asseveratore_tecnico;
        },
        // if: (values: Record<string, any>) =>
        //   values["limite-importo-complessivo"] !== "1",
      },
    ],
  },
];

export default form;
